import ReactGA from "react-ga4";



const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID;


export const initGA = () => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const trackPage = (path) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};

export const trackEvent = (action, category, label) => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event({
    action,
    category,
    label,
  });
};
